import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./style.css";

document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".banner-hero-swiper");

  containers.forEach((el) => {
    new Swiper(el, {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: el.parentElement.querySelector(".banner-hero-next"),
        prevEl: el.parentElement.querySelector(".banner-hero-prev"),
      },
      pagination: {
        el: el.parentElement.querySelector(".banner-hero-pagination"),
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<button class="' +
            className +
            ' !w-2 !h-2 !rounded-full !bg-zinc-900 opacity-40 transition-all duration-200 cursor-pointer"></button>'
          );
        },
      },
    });
  });
});
